import React from 'react';
import './Availability.css';

interface AvailabilityPreviewProps {
  availabilityData: any;
}

const AvailabilityPreview: React.FC<AvailabilityPreviewProps> = ({
    availabilityData
}) => {
  if (!availabilityData) {
    return null;
  }
  
  const currentYear = new Date().getFullYear().toString();
  const years = Object.keys(availabilityData);
  const yearToUse = years.includes(currentYear) ? currentYear : years[0];
  
  if (!yearToUse || !availabilityData[yearToUse]) {
    return null;
  }
  
  const allMonths = [
    'january', 'february', 'march', 'april', 'may', 'june', 
    'july', 'august', 'september', 'october', 'november', 'december'
  ];
  
  const currentMonthIndex = new Date().getMonth();
  
  const nextMonths = [];
  for (let i = 0; i < 6; i++) {
    const monthIndex = (currentMonthIndex + i) % 12;
    nextMonths.push(allMonths[monthIndex]);
  }
  
  const getColorForPercentage = (percentStr: any) => {
    if (!percentStr) return '#f5f5f5';

    const percent = typeof percentStr === 'string' ? 
        parseInt(percentStr.replace('%', ''), 10) : 0;

    if (isNaN(percent)) return '#f5f5f5';

    const saturation = 95;
    const lightness = 75;

    const hue = Math.round((percent / 100) * 120);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };
  
  return (
    <div className="availability-preview">
      <div className="preview-label">Availability:</div>
      <div className="preview-dots">
        {nextMonths.map((month, index) => {
          const yearData = availabilityData[yearToUse] || {};
          const percentValue = yearData[month] || '0%';
          const bgColor = getColorForPercentage(percentValue);
          
          return (
            <div key={index} className="month-dot-container">
              <div 
                className="month-dot"
                style={{ backgroundColor: bgColor }}
                title={`${month.charAt(0).toUpperCase() + month.slice(1)}: ${percentValue}`}
              />
              <div className="month-label">{month.charAt(0).toUpperCase()}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AvailabilityPreview;